import { updateDiscoveryRule } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    discoveryRule?: any,
    discovery_rule?: any,
}

export async function  processDiscoveryRuleDataGrid ({
    discoveryRule,
    discovery_rule,
    eventEmitter,
}: Props) {
    const rule = discoveryRule ?? discovery_rule;
    if (!rule) return;

    await updateDiscoveryRule({
        discovery_rule_id: rule.discovery_rule_id,
        discovery_rule: rule.discovery_rule,
        id: rule.id,
        mode: 'edit',
        category: rule.category,
        type: rule.type,
        discovery_rule_type: rule.discovery_rule_type,
        discovery_rule_detail: rule.discovery_rule_detail,
        source: rule.source,
        tasks: rule.tasks,
        events: rule.events,
        calculate_cost_impact: rule.calculate_cost_impact, 
        automation_opportunity: rule.automation_opportunity,
        filters: rule.filters,
    },'','processDiscoveryRule')
    apiProvider.processDiscoveryRuleUpdateDiagram({})
    eventEmitter.emit(Event.setActionBar_Visualizer)
    
};

